import React from "react";

function L4AComponentCode({title}) {
    title = 'Your Journey';

    return (

        <div className="lego l004">
            <h2 className="subHeadAllCaps2">{title}</h2>
        </div>

    )
};


export default L4AComponentCode;